import {
  Button,
  Grid,
  Typography
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useHistory } from "react-router-dom";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { useLocalStorage } from "../utils/LocalStorageHook";
import { checkForRole } from "../utils/GetAuth";
import {
  Description,
  Store,
  PlaylistAddCheck,
  Dashboard,
  Explore,
  Assessment,
  List,
  SwapHoriz
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getPublicImagePath } from "../App";
import { getSettingsData,saveSettingsData} from "src/utils/GetSettingsData";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      margin: 0,
      padding: theme.spacing(8),
      maxHeight: "40vh"
    },
    primary: {
      marginTop: theme.spacing(2)
    },
    paragraph: {
      padding: theme.spacing(1)
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  }));

export default function LandingPage() {
  const classes = useStyles();
  const history = useHistory();
  const [userAccessLS] = useLocalStorage(
    "SETTINGS.userAccess",
    {}
  );
  const [userAccess] = useState<any>(userAccessLS);
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [darkMode, setDarkMode] = useLocalStorage("SETTINGS.darkmode", false);
  useEffect(() => {
    settings()
  }, [])

  if (Object.keys(userAccess).length < 1) return <div>Unauthorized.</div>;


 
  let settings=()=>{
    getSettingsData(salesOrg).then((v) => {
      for (let i=0;i<v?.data?.length;i++){
      if(v?.data[i]?.colKey === 'SETTINGS.darkmode'){
        setDarkMode(v?.data[i]?.colVal=='true'?true:false);
        if( !localStorage.getItem('firstLoad')  &&  v?.data[i]?.colVal=='true')
        {
          localStorage['firstLoad'] = true;
          window.location.reload();
        }  
        else{
          localStorage.removeItem('firstLoad');
      }
    
    }
     }
   });
  }
  
  return (
    <ResponsiveDrawer
      title="CONA NextGen Vending"
    >
      <Grid container spacing={1} className={classes.primary}>
        <Grid item xs={12} md={6} xl={3}>
          <img alt="VendPrime" className={classes.image} src={getPublicImagePath(`/vendprime.png`)}></img>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <Typography variant="h3" className={classes.paragraph}>
            VendPrime
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            VendPrime is a recommendation and optimization system for vending
            machines that suggest new products and their corresponding quantity
            to be stocked in these vending machines. These recommendations are
            provided as input to the VendPrime tool which can generate the
            optimized layout of a vending machine on a button click which is
            then used by truck drivers while refilling the machine. The
            recommendations are refreshed every four to six months.
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            During machine optimization, a view of the sequence of products in
            the vending machine and the number of columns to be allocated per
            product is generated after considering the recommendations and
            removing products to accommodate the new products if required.
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            A recommended product might not be added to a vending machine if the
            sales generated by the existing combination of products is computed
            to be greater than the sales estimated to be generated by the new
            product.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            className={classes.paragraphButton}
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vp_access")
            }
            onClick={() => history.push("/customers")}
          >
            <Store />
            Customers
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.paragraphButton}
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vp_access")
            }
            onClick={() => history.push("/materialswap")}
          >
            <SwapHoriz />
            Material Swap
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.paragraphButton}
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vp_approve_ticket")
            }
            onClick={() => history.push("/vendprime/queue")}
          >
            <PlaylistAddCheck />
            Queue
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.paragraphButton}
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vp_access")
            }
            onClick={() => history.push("/vendprime/monitor")}
          >
            <List />
            Monitor
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.paragraphButton}
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vp_access")
            }
            onClick={() => history.push("/vendprime/notes")}
          >
            <Description />
            Driver Notes
          </Button>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <img alt="VendSmart" className={classes.image} src={getPublicImagePath(`/vendsmart.png`)}></img>
        </Grid>
        <Grid item xs={12} md={6} xl={3}>
          <Typography variant="h3" className={classes.paragraph}>
            VendSmart
          </Typography>
          <Typography
            variant="subtitle1"
            className={classes.paragraphAct}
            paragraph
          >
            Vend Smart is an integrated solution for planning the replenishment
            of vending machines. It utilizes mathematical modeling to determine
            the optimum replenishment schedule for vending machines, with the
            goal of minimizing the visit frequency as well as the chances that
            any product will run out of stock. It makes these projections based
            on information such as historical replenishment data, online
            telemetry data of current inventory levels, sales per weekday,
            machine access days, and the consigned materials and quantities per
            machine. The proposed replenishment data can be viewed and adjusted
            by a vending planner before he/she finalizes the scheduled visits
            for a given date. Once the schedule is finalized, the associated
            data is sent to the ERP system for subsequent picking, loading, and
            execution.
          </Typography>
          <Button
            color="primary"
            variant="contained"
            disabled={
              Object.keys(userAccess).length > 1 &&
              !checkForRole(clientId, salesOrg, "vs_access")
            }
            className={classes.paragraphButton}
            onClick={() => history.push("/customers")}
          >
            <Store />
            Customers
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/telemeter_dashboard")}
            
          >
            <Dashboard />
            Telemeter Dashboard
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/vendsmart/planning")}
          >
            <Explore />
            Route Planning
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/configuration")}
          >
            <Assessment />
            Reporting (Configuration)
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/utilization")}
          >
            <Assessment />
            Reporting (Utilization)
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/planning")}
          >
            <Assessment />
            Reporting (Planning)
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/fillrate")}
          >
            <Assessment />
            Reporting (Average Fill Rate)
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/missedstop")}
          >
            <Assessment />
            Reporting (Missed Stops)
          </Button>               
          <Button
            color="primary"
            variant="contained"
            disabled={Object.keys(userAccess).length > 1 && true}
            className={classes.paragraphButton}
            onClick={() => history.push("/reporting/vmdex")}
          >
            <Assessment />
            Reporting (VM-DEX)
          </Button>   
        </Grid>
      </Grid>
    </ResponsiveDrawer>
  );

  // onClick={() => history.push("/vendsmart/planning")}
}